import React, { useEffect } from "react";
import DownlineMembersTable from "../../components/Tree/DownlineMembersTable";
import { useState } from "react";
import TreeViewNavbar from "../../components/Tree/TreeViewNavbar";
import { useSelector } from "react-redux";
import { getUserDefaultPlan } from "../../utils/defaultPlan";

const DownlineMembers = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [treePlan, setTreePlan] = useState(null);
  const userPlans = useSelector((state) => {
    return state.dashboard?.appLayout?.userplans;
  });
  const userDefaultPlan = getUserDefaultPlan();

  useEffect(() => {
    if (userDefaultPlan) {
      setTreePlan(userDefaultPlan);
    } else if (userPlans?.defaultPlan) {
      setTreePlan(userPlans.defaultPlan);
    }
  }, [userPlans, userDefaultPlan]);
  return (
    <>
      {treePlan && <>
        <TreeViewNavbar menu={"downlineMembers"} treePlan={treePlan} setTreePlan={setTreePlan} />
        <DownlineMembersTable
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          treePlan={treePlan}
        />
      </>}
    </>
  );
};

export default DownlineMembers;
